// extracted by mini-css-extract-plugin
export default {"ChannelLinks":"ChannelLinks_ChannelLinks__OSJ66","channel":"ChannelLinks_channel__IT-d+","socialIcons":"ChannelLinks_socialIcons__Irqrn"};